const { LOCAL_CORE_CONFIG } = require('./core');

const PROTOCOL = 'https';
const HOST = 'localhost';
const PORT = 443;
const LOCAL_FO_URL = `${PROTOCOL}://${HOST}:${PORT}`;
const WIDGET_ENTRY_POINT_NAME = 'getBootstrapAPI';
const WHITE_LIST_LOCAL_DOMAIN = `${PROTOCOL}://spark-ubisoft-connect.ubi.com:${PORT}`;

const EMBEDDED_MODE_CONSTANTS = {
    CORE_CDN_PATH: '__CORE_CDN_PATH__',
    WEBSITE_CONFIG: '__WEBSITE_CONFIG__',
    WEBSITE_ENTRY_POINT_NAME: '__WEBSITE_ENTRY_POINT_NAME__'
};

module.exports.LOCAL_FO_CONFIG = {
    HOST,
    PORT,
    PROTOCOL,
    LOCAL_FO_URL,
    WIDGET_ENTRY_POINT_NAME,
    WHITE_LIST_LOCAL_DOMAIN
};

module.exports.EMBEDDED_MODE_CONSTANTS = EMBEDDED_MODE_CONSTANTS;

module.exports.embeddedModeVariables = {
    [EMBEDDED_MODE_CONSTANTS.CORE_CDN_PATH]: JSON.stringify(LOCAL_CORE_CONFIG.LOCAL_CORE_URL),
    [EMBEDDED_MODE_CONSTANTS.WEBSITE_ENTRY_POINT_NAME]: JSON.stringify(WIDGET_ENTRY_POINT_NAME)
};
